import styles from "./main.module.css";
import {motion} from "framer-motion"
import {EnvSwitch} from "../components/ui/EnvSwitch";
const Main = ({ isInView }) => {
  return (
    <section
        id="Intro" className={styles.mainContainer} data-page="01">
      <motion.div animate={{ opacity: 1, y: 0 }}
                  initial={{ opacity: 0, y: 20 }}
                  exit={{ opacity: 0, y: 20 }}
                  transition={{ duration: 0.5 }}>
        <h1>
          Godefroy
          <br />
          <span>Axel</span>
        </h1>
          <EnvSwitch env={"portfolio"}>
              <p>
                  Étudiant à l'ESGI au sein du mastère ingénierie web, actuellement en
                  alternance dans le domaine du développement Web.
              </p>
          </EnvSwitch>
          <EnvSwitch env={"freelance"}>
              <p>
                  Je vous accompagne pour moderniser votre présence en ligne avec des sites clairs, efficaces et faciles à gérer — pour entreprises, associations, ou événements locaux.
              </p>
          </EnvSwitch>
      </motion.div>
    </section>
  );
};

export default Main;
